module.exports = __webpack_public_path__ + "static/img/aboutus.4d5cc0a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_icons/aboutus.jpeg
// module id = q/tO
// module chunks = 4